import clsx from 'clsx'
import { useState } from 'react'
import ReactPlayer from 'react-player'
import { Link } from 'react-router-dom'

import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg'
import { ReactComponent as ExternalLinkIcon } from 'assets/icons/external-link-icon.svg'
import { FullScreenModal } from 'components/common/FullScreenModal/FullScreenModal'
import { Icon } from 'components/common/Icon/Icon'
import { Typography } from 'components/common/typography/Typography'
import { AnalyticsActionType } from 'types/analytics.type'

import { HowSubheadMockData } from './HowSubheadMockData'
import { trackAnalytics } from '../../utils/analytics'
import Bubble from '../common/bubble/Bubble'
import { Flex } from '../common/flex/Flex'
import TitleText from '../common/titleText/TitleText'
import styles from '../howSubhead/HowSubhead.module.scss'

const title = 'The Why, the How, the Wow'
const text = 'All the processes and resources you need to say, “Now that’s how it’s done!”'
const bubbleText = 'Never medium... always well done!'

const HowSubhead = () => {
  const [videoUrl, setVideoUrl] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const handleCloseModal = () => {
    setVideoUrl('')
    setIsModalOpen(false)
  }

  const handleCardClick = (card: any) => {
    if (card.video_src) {
      setVideoUrl(card.video_src)
      setIsModalOpen(true)
    }

    trackAnalytics({
      type: 'Action' as AnalyticsActionType,
      payload: card.event_type,
    })
  }

  return (
    <div className={styles.container}>
      <TitleText
        containerClassName={styles.titleContainer}
        titleClassName={`${styles.title} text-[#680101]`}
        textClassName={styles.text}
        titleTag="h2"
        textTag="p"
        titleType="5xl-display"
        textType="m-body"
        title={title}
        text={text}
      >
        <Bubble text={bubbleText} className={styles.bubble} direction="down" />
      </TitleText>
      <div className={styles.contentContainer}>
        {HowSubheadMockData.map((card, index) => {
          return (
            <Link
              to={card.link}
              className={clsx(styles.cardContainer, { [styles.defaultCursor]: !card.link && !card.video_src })}
              key={card.title}
              onClick={() => handleCardClick(card)}
            >
              {card.coming_soon && (
                <Bubble
                  text="COMING SOON!"
                  className={clsx(
                    card.coming_soon_position === 'left' ? styles.comingBubbleLeft : styles.comingBubbleRight,
                  )}
                  direction="down"
                />
              )}
              <div className={styles.imgContainer} style={{ backgroundColor: card.background }}>
                <img src={card.img} alt="" />
              </div>
              <div className={styles.contentWrapper}>
                <div className={styles.subtitleContainer} style={index === 3 ? { marginBottom: '0' } : {}}>
                  <Typography type="m-strong" className={styles.cardTitle} color="#680101">
                    {card.title}
                  </Typography>
                  {card.icon === 'arrow' && <Icon icon={ArrowRightIcon} color="#680101" />}
                  {card.icon === 'external' && <Icon icon={ExternalLinkIcon} color="#680101" />}
                </div>
                <Typography type="s-body" className={styles.cardText}>
                  {card.description}
                </Typography>
              </div>
            </Link>
          )
        })}
      </div>
      <FullScreenModal className={styles.videoModal} open={isModalOpen}>
        <Flex justify="end" slot="header" className="w-full">
          <button onClick={() => handleCloseModal()}>
            <Icon icon={CloseIcon} />
          </button>
        </Flex>
        <div slot="body">
          <ReactPlayer
            url={videoUrl}
            controls={true}
            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
            width="100%"
            height="100%"
          />
        </div>
      </FullScreenModal>
    </div>
  )
}

export default HowSubhead
